import formsDocumentUploadImage from './document-upload.png';
import formsMarketingImage from './forms-marketing-temp.png';

export const FORMS_IMAGES = {
  formsDocumentUploadImage,
  formsMarketingImage,
};
